import React from 'react';
import { Helmet } from "react-helmet";

function About() {
  const teamMembers = [
    {
      name: 'Giulia Santoro',
      role: 'Fondatrice e Direttrice Creativa',
      bio: 'Con oltre 20 anni di esperienza nella fotografia editoriale e artistica, Giulia guida la visione creativa di Haridem con passione e maestria unica.',
      image: '/images/team_1.jpg'
    },
    {
      name: 'Elena Rossetti',
      role: 'Fotografa Senior Ritratti',
      bio: 'Specializzata in ritratti emozionali e fotografia fashion, Elena porta sensibilita artistica e tecnica impeccabile in ogni scatto che realizza.',
      image: '/images/team_2.jpg'
    },
    {
      name: 'Marco De Luca',
      role: 'Fotografo Wedding e Eventi',
      bio: 'Esperto in fotografia matrimoniale cinematografica, Marco cattura i momenti piu preziosi con stile documentaristico e attenzione ai dettagli.',
      image: '/images/team_3.jpg'
    },
    {
      name: 'Chiara Fontana',
      role: 'Fotografa Corporate e Commerciale',
      bio: 'Con background in fotografia pubblicitaria internazionale, Chiara crea immagini corporate di impatto che valorizzano l identita aziendale.',
      image: '/images/team_4.jpg'
    },
    {
      name: 'Luca Moretti',
      role: 'Direttore Post-Produzione',
      bio: 'Maestro del ritocco fotografico e color grading cinematografico, Luca trasforma ogni immagine in opera d arte attraverso tecniche avanzate.',
      image: '/images/team_5.jpg'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Haridem - Photography Studio Premium | Servizi Fotografici Professionali</title>
        <meta name="description" content="Haridem Photography Studio - Servizi fotografici professionali premium, ritratti artistici, gallerie contemporanee e attrezzatura fotografica di alta qualita" />
      </Helmet>

      <div className="about-container">
      <div className="about-hero">
        <h1>Chi Siamo</h1>
        <p>
          Haridem Photography Studio e uno studio fotografico premium specializzato in fotografia 
          artistica contemporanea, ritrattistica emozionale e servizi fotografici professionali di 
          alta qualita. Con sede nel cuore dell Italia, combiniamo tradizione fotografica italiana 
          con innovazione tecnologica per creare immagini straordinarie che raccontano storie uniche.
        </p>
        <p>
          Fondata nel 2010, la nostra missione e quella di elevare la fotografia a forma d arte 
          autentica, catturando l essenza dei nostri soggetti attraverso composizioni visive 
          cinematografiche, illuminazione sofisticata e post-produzione artistica di livello 
          mondiale. Ogni progetto e un opportunita per creare qualcosa di straordinario.
        </p>
      </div>

      <section className="team-section">
        <h2 className="team-title">Il Nostro Team Creativo</h2>
        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div key={index} className="team-member">
              <img 
                src={member.image} 
                width="400" 
                height="400" 
                alt={`Team member ${index + 1}`}
              />
              <div className="team-info">
                <h3>{member.name}</h3>
                <p className="team-role">{member.role}</p>
                <p className="team-bio">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="about-hero">
        <h2>La Nostra Filosofia</h2>
        <p>
          Crediamo che ogni fotografia debba raccontare una storia autentica e emozionante. 
          Il nostro approccio combina tecnica fotografica impeccabile con sensibilita artistica 
          profonda, creando immagini che non sono semplicemente belle, ma significative e senza tempo.
        </p>
        <p>
          Investiamo costantemente in formazione professionale, tecnologia all avanguardia e 
          ricerca artistica per garantire che ogni servizio fotografico superi le aspettative 
          dei nostri clienti. La vostra soddisfazione e il nostro successo piu grande.
        </p>
      </section>
    </div>
  
    </>);
}

export default About;